import React from 'react'
import { SSOPlatformLink } from '@app/components/ui/buttons/PlatformLink'
import classnames from 'classnames'

const Platform = ({ className, theme, ...props }) => {
  if (window.COUNTRY === 'CN' || window.COUNTRY === 'IN' ) { return null }

  const classes = classnames(
    'platform',
    { 'platform--white': theme == 'white' },
    className
  )

  return ( <SSOPlatformLink className={classes} {...props} /> )
}

Platform.defaultProps = {
  theme: "default"
}

export default Platform
